<ng-container
  *ngIf="{
    isPopoverDisplayed: isPopoverDisplayed$ | async,
    suggestion: suggestion$ | async
  } as asyncData">
  <ng-container *ngIf="asyncData.isPopoverDisplayed">
    <div class="suggestion-container" [@fadeOutDown]="{ value: animationState }">
      <ion-header>
        <ion-toolbar>
          <ion-title>
            <div class="title-wrapper">
              <!-- room_service is a mat icon, but mat icons are not availaible in widget... -->
              <ion-icon slot="icon-only" src="assets/img/room_service.svg"></ion-icon>
              <span translate="m/task-process/ai-assistant/modale/title"></span>&nbsp;

              <app-ai-assistant-suggestion-knowledge-documents
                [suggestion]="asyncData.suggestion"></app-ai-assistant-suggestion-knowledge-documents>
            </div>
          </ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="minimizeAIAssistantAnswer()">
              <div class="title-close-wrapper">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </div>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content>
        <div class="answer-wrapper">{{ asyncData.suggestion.answer }}</div>
        <div class="footer-wrapper">
          <div>
            <ion-button
              fill="solid"
              size="default"
              class="use-suggestion-btn"
              (click)="emitAcceptedAIAssistantAnswer(asyncData.suggestion)">
              <span translate="m/task-process/ai-assistant/modale/label-use"></span>
            </ion-button>
            <span class="submit-description" translate="m/task-process/ai-assistant/modale/description"></span>
          </div>
          <ion-button
            fill="outline"
            size="default"
            class="reject-suggestion-btn"
            (click)="rejectAIAssistantAnswer(asyncData.suggestion)">
            <span translate="m/task-process/ai-assistant/modale/label-reject"></span>
          </ion-button>
        </div>
      </ion-content>
    </div>
  </ng-container>
</ng-container>
